import { useTranslation } from 'react-i18next';

import gradients from 'src/shared/utils/gradients';
import InsertChartOutlinedOutlinedIcon from '@mui/icons-material/InsertChartOutlinedOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import { formatCurrency } from 'src/shared/utils/currency';
import { type CurrentCompanyType, type PayflowStatisticsData } from './types';

export const payflowStatisticsData =
  (
    t: any,
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    theme: any,
    currentCompany: CurrentCompanyType
  ) =>
  (paymentTotals: PayflowStatisticsData) => {
    const formatCompanyCurrency = formatCurrency(currentCompany?.locale, currentCompany?.currency);

    return {
      title: t('common:payflow'),
      gradient: gradients.blue,
      data: [
        {
          headline: t('total requested'),
          value: formatCompanyCurrency(paymentTotals?.totalAmount || 0),
          icon: <MonetizationOnOutlinedIcon style={{ color: theme.palette.colorPalette[1] }} />
        },
        {
          headline: t('average amount'),
          value: formatCompanyCurrency(paymentTotals?.averageAmount || 0),
          icon: <InsertChartOutlinedOutlinedIcon style={{ color: theme.palette.colorPalette[1] }} />
        },
        {
          headline: `${t('common:no')} ${t('of applications')}`,
          value: paymentTotals?.totalCount,
          icon: <HowToRegOutlinedIcon style={{ color: theme.palette.colorPalette[1] }} />
        }
      ]
    };
  };
